module.exports = __webpack_public_path__ + "static/media/robotoi3.14286f3b.woff2";